window.Blimp = window.Blimp || {};

class Photo extends Backbone.Model {
  taken_at() {
    if (this.has('taken_at')) {
      return moment(this.get('taken_at'));
    }
  }

  index() {
    return this.report.photos.indexOf(this) + 1;
  }

  previous() {
    return this.report.photos.at(this.report.photos.indexOf(this) - 1) || this.report.photos.last();
  }

  next() {
    return this.report.photos.at(this.report.photos.indexOf(this) + 1) || this.report.photos.first();
  }

  isNew() {
    return false;
  }

  url() {
    return `${this.report.url()}/photos/${this.index()}`;
  }

  download_url() {
    return `${this.url()}/download`;
  }

  thumb_url() {
    if (this.report.get('limited')) {
      return `${Blimp.s3_url}/${this.report.get('public_id')}/${this.get('limited_id')}_blur.jpg`;
    } else if (this.report.get('thumbs_generated')) {
      return `${Blimp.s3_url}/${this.report.get('public_id')}/${this.get('public_id')}_thumb.jpg`;
    } else {
      return this.zoom_url();
    }
  }

  is_image() {
    return this.get('image?');
  }

  is_video() {
    return this.get('video?');
  }

  zoom_url() {
    return `${Blimp.s3_url}/${this.report.get('public_id')}/${this.get('public_id')}.${this.get('file_extension') || 'jpg'}`;
  }
}

Blimp.Photo = Photo;